import { render } from "./MfittBooking3.vue?vue&type=template&id=14b6f62c"
import script from "./MfittBooking3.vue?vue&type=script&lang=js"
export * from "./MfittBooking3.vue?vue&type=script&lang=js"
script.render = render

export default script